<template>
  <div class="settings-page">
    <div class="page-header">
      <h2>系统设置</h2>
    </div>
    <el-card class="settings-card">
      <h3>基本设置</h3>
      <el-form :model="settings" label-width="120px">
        <el-form-item label="系统名称">
          <el-input v-model="settings.systemName"></el-input>
        </el-form-item>
        <el-form-item label="系统描述">
          <el-input type="textarea" v-model="settings.description" :rows="3"></el-input>
        </el-form-item>
        <el-form-item label="主题颜色">
          <el-select v-model="settings.theme">
            <el-option label="蓝色" value="blue"></el-option>
            <el-option label="绿色" value="green"></el-option>
            <el-option label="紫色" value="purple"></el-option>
            <el-option label="橙色" value="orange"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="自动保存">
          <el-switch v-model="settings.autoSave"></el-switch>
        </el-form-item>
        <el-form-item label="通知提醒">
          <el-switch v-model="settings.notifications"></el-switch>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveSettings">保存设置</el-button>
          <el-button @click="resetSettings">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card class="settings-card">
      <h3>安全设置</h3>
      <el-form :model="securitySettings" label-width="120px">
        <el-form-item label="登录超时时间">
          <el-select v-model="securitySettings.sessionTimeout">
            <el-option label="15分钟" value="15"></el-option>
            <el-option label="30分钟" value="30"></el-option>
            <el-option label="1小时" value="60"></el-option>
            <el-option label="2小时" value="120"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="密码过期时间">
          <el-select v-model="securitySettings.passwordExpire">
            <el-option label="7天" value="7"></el-option>
            <el-option label="15天" value="15"></el-option>
            <el-option label="30天" value="30"></el-option>
            <el-option label="90天" value="90"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="启用双因素认证">
          <el-switch v-model="securitySettings.twoFactor"></el-switch>
        </el-form-item>
        <el-form-item label="允许登录尝试次数">
          <el-input-number v-model="securitySettings.loginAttempts" :min="3" :max="10"></el-input-number>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveSecuritySettings">保存安全设置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'Settings',
  data () {
    return {
      settings: {
        systemName: '后台管理系统',
        description: '基于Vue2的后台管理系统模板',
        theme: 'blue',
        autoSave: true,
        notifications: true
      },
      securitySettings: {
        sessionTimeout: '30',
        passwordExpire: '30',
        twoFactor: false,
        loginAttempts: 5
      }
    }
  },
  methods: {
    saveSettings () {
      this.$message.success('基本设置已保存')
    },
    resetSettings () {
      this.settings = {
        systemName: '后台管理系统',
        description: '基于Vue2的后台管理系统模板',
        theme: 'blue',
        autoSave: true,
        notifications: true
      }
      this.$message.info('已重置为默认设置')
    },
    saveSecuritySettings () {
      this.$message.success('安全设置已保存')
    }
  }
}
</script>

<style scoped>
.settings-page {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  font-size: 20px;
}

.settings-card {
  margin-bottom: 20px;
  padding: 20px;
}

.settings-card h3 {
  margin: 0 0 20px 0;
  font-size: 16px;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}
</style>
